import React from "react";

import type { OperatorDescriptionWrapperProps } from "./types";

/**
 * Transparent wrapper that exposes rich content to the Operator page scraper
 * via `data-operator-description`. The scraper uses this attribute to understand
 * content hidden inside cross-origin iframes (Beefree, GrapesJS, Craft.js).
 *
 * Renders as `display: contents` so it has zero layout impact.
 */
export const OperatorDescriptionWrapper = ({
  description,
  children,
  enabled = true,
}: OperatorDescriptionWrapperProps) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: "contents" }} data-operator-description={description}>
      {children}
    </div>
  );
};
